export default __webpack_public_path__ + "static/media/Icon-Other.b2bc4886.svg";